export default "__VITE_ASSET__BkqiGH7s__"